export default __webpack_public_path__ + "static/media/312-Series-Brass-Regulators.c99c9b05.jpg";